import { render, staticRenderFns } from "./BnCaption.vue?vue&type=template&id=acfd22f6&scoped=true&"
import script from "./BnCaption.vue?vue&type=script&lang=js&"
export * from "./BnCaption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acfd22f6",
  null
  
)

export default component.exports